import { Injectable } from '@angular/core';
import { StageInterface } from '@vendasta/sales-opportunities';
import { BehaviorSubject, Observable, ReplaySubject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { Pipeline } from '@vendasta/sales-common';
import { UserPipelines } from '../../pipelines/user-pipelines/user-pipelines';

@Injectable()
export class PipelineMultiSelectService {
  readonly selectablePipelines$: Observable<Pipeline[]>;

  private readonly selectedPipelines$$ = new ReplaySubject<Pipeline[]>(1);
  readonly selectedPipelines$ = this.selectedPipelines$$.asObservable().pipe(filter((v) => !!v));
  private readonly selectedPipelineStage$$ = new BehaviorSubject<StageInterface>(null);
  readonly selectedPipelineStage$ = this.selectedPipelineStage$$.asObservable();

  constructor(private userPipelines: UserPipelines) {
    this.selectablePipelines$ = this.userPipelines.partnerPipelines$;
  }

  public setPipelineSelection(pipelines: Pipeline[]): void {
    this.selectedPipelines$$.next(pipelines);
  }

  public clearPipelineSelection(): void {
    this.selectedPipelines$$.next([]);
  }

  public setPipelineStageSelection(stage: StageInterface): void {
    this.selectedPipelineStage$$.next(stage);
  }

  public clearPipelineStageSelection(): void {
    this.selectedPipelineStage$$.next(null);
  }
}
